import axios from './axiosInstance';

export const lessonsList = async (params = {}) => {
  const response = await axios.get("/club_api/lessons", { params });
  return response.data;
};

export const lessonDetails = async (id) => {
  const response = await axios.get("/club_api/lessons/" + id);
  return response.data;
};

export const saveLesson = async (lesson) => {
  const response = !lesson?.id ? await axios.post("/club_api/lessons/", { lesson } ) : await axios.put("/club_api/lessons/" + lesson.id, { lesson } );
  return response.data;
};

export const removeLesson = async (id) => {
  const response = await axios.delete("/club_api/lessons/" + id);
  return response.data;
};

export const lessonUsers = async (id, params = {}) => {
  const response = await axios.get(`/club_api/lessons/${id}/users`, { params });
  return response.data;
};

export const notifyUsers = async (lessonId, params = {}) => {
  const response = await axios.post(`/club_api/lessons/${lessonId}/users/notify`, params);
  return response.data;
};
